<div class="image-organizer-main" data-cy="tdo-organizer-container">
  <div style="flex-basis: 334px; display: flex; flex-direction: column; height: 100%; overflow-y: hidden;"
    data-cy="tdo-organizer-left-panel">
    <div class="io-top-left-buttons" style="flex-basis: 30px" data-cy="tdo-organizer-top-left-buttons">
      <!-- @if (!isPickList) {
      <div (click)="openCollageInNewWindow()" data-cy="tdo-organizer-publish-button">Publish</div>
      } -->
      @if (!isPickList) {
      <div (click)="onOpenImagingInNewWindowClick()" data-cy="tdo-organizer-studio-button">Studio</div>
      }
    </div>
    <div
      style="flex: 1; background-color: var(--tdo-background); margin-top: var(--margin-size); border-radius: var(--border-radius); max-height: 100%; overflow-y: hidden;"
      data-cy="tdo-organizer-tabs-container">
      <mat-tab-group [selectedIndex]="selectedTab" style="width: 334px;" data-cy="tdo-organizer-tabs">
        @if (!hidePatientTab) {
        <mat-tab label="Patient" data-cy="tdo-organizer-patient-tab">
          <div class="image-organizer-tab-content" data-cy="tdo-organizer-patient-tab-content">
            @if (patientTreeData.length > 0) {
            <tdo-tree #patientTree (itemSelected)="onPatientTreeItemSelected($event)" [dataSource]="patientTreeData"
              (itemDrop)="onPatientItemDroppedInTree($event)" [template]="treeItem"
              data-cy="tdo-organizer-patient-tree">
              <ng-template #treeItem let-item>
                <div (contextmenu)="onPatientTreeContext($event, item); false" cdkDropList
                  style="display: flex; cursor: pointer; font-size: 14px;" data-cy="tdo-organizer-patient-tree-item">
                  @if (item.matIconOverride) {
                  <lucide-icon name="trash-2" [size]="30"
                    [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"
                    data-cy="tdo-organizer-patient-tree-item-delete-icon"></lucide-icon>
                  }
                  @if (!item.matIconOverride) {
                  @if (!item.isExpanded && !isItemSelected(item)) {
                  <div style="flex-basis: 36px;" data-cy="tdo-organizer-patient-tree-item-closed-folder">
                    <lucide-icon [name]="item.children?.length > 0 ? 'folder-input' : 'folder'" [size]="30"
                      class="tree-item-icon"
                      [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"></lucide-icon>
                  </div>
                  }
                  @if (item.isExpanded || isItemSelected(item)) {
                  <div style="flex-basis: 36px;" data-cy="tdo-organizer-patient-tree-item-open-folder">
                    <lucide-icon [name]="item.children?.length > 0 ? 'folder-open-dot' : isItemSelected(item)?'folder-open':'folder'" [size]="30" 
                      class="tree-item-icon"
                      [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"></lucide-icon>
                  </div>
                  }
                  }
                  <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                    [ngClass]="{'selected-item': isItemSelected(item)}" data-cy="tdo-organizer-patient-tree-item-name">
                    {{item.name}}</div>
                </div>
              </ng-template>
            </tdo-tree>
            }
          </div>
        </mat-tab>
        }
        @if (!hideLibraryTab) {
        <mat-tab label="Library" data-cy="tdo-organizer-library-tab">
          <div class="image-organizer-tab-content" data-cy="tdo-organizer-library-tab-content">
            @if (libraryTreeData.length > 0) {
            <tdo-tree #libraryTree (itemSelected)="onPatientTreeItemSelected($event)" [dataSource]="libraryTreeData"
              [template]="treeItem2" (itemDrop)="onItemDroppedInTree($event)" data-cy="tdo-organizer-library-tree">
              <ng-template #treeItem2 let-item>
                <div (contextmenu)="onLibraryTreeContext($event, item); false"
                  style="display: flex; cursor: pointer; font-size: 14px;" data-cy="tdo-organizer-library-tree-item">
                  @if (item.matIconOverride) {
                  <lucide-icon name="trash-2" [size]="30"
                    [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"
                    data-cy="tdo-organizer-patient-tree-item-delete-icon"></lucide-icon>
                  }
                  @if (!item.matIconOverride) {
                  @if (!item.isExpanded && !isItemSelected(item)) {
                  <div style="flex-basis: 36px;" data-cy="tdo-organizer-library-tree-item-closed-folder">
                    <lucide-icon [name]="item.children?.length > 0 ? 'folder-input' : 'folder'" [size]="30"
                      class="tree-item-icon"
                      [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"></lucide-icon>
                  </div>
                  }
                  @if (item.isExpanded || isItemSelected(item)) {
                  <div style="flex-basis: 36px;" data-cy="tdo-organizer-library-tree-item-open-folder">
                    <lucide-icon [name]="item.children?.length > 0 ? 'folder-open-dot' : isItemSelected(item)?'folder-open':'folder'" [size]="30" 
                      class="tree-item-icon"
                      [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"></lucide-icon>
                  </div>
                  }
                  }
                  <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                    [ngClass]="{'selected-item': isItemSelected(item)}" data-cy="tdo-organizer-library-tree-item-name">
                    {{item.name}}</div>
                </div>
              </ng-template>
            </tdo-tree>
            }
          </div>
        </mat-tab>
        }
        @if (!hideLectureTab) {
        <mat-tab label="Lecture" data-cy="tdo-organizer-lecture-tab">
          <div class="image-organizer-tab-content" data-cy="tdo-organizer-lecture-tab-content">
            @if (libraryTreeData.length > 0) {
            <tdo-tree #libraryTree (itemSelected)="onPatientTreeItemSelected($event)" [dataSource]="lectureTreeData"
              [template]="treeItem3" (itemDrop)="onItemDroppedInTree($event)" data-cy="tdo-organizer-lecture-tree">
              <ng-template #treeItem3 let-item>
                <div (contextmenu)="onLibraryTreeContext($event, item); false"
                  style="display: flex; cursor: pointer; font-size: 14px;" data-cy="tdo-organizer-lecture-tree-item">
                  @if (item.matIconOverride) {
                  <lucide-icon name="trash-2" [size]="30"
                    [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"
                    data-cy="tdo-organizer-patient-tree-item-delete-icon"></lucide-icon>
                  }
                  @if (!item.matIconOverride) {
                  @if (!item.isExpanded && !isItemSelected(item)) {
                  <div style="flex-basis: 36px;" data-cy="tdo-organizer-lecture-tree-item-closed-folder">
                    <lucide-icon [name]="item.children?.length > 0 ? 'folder-input' : 'folder'" [size]="30"
                      class="tree-item-icon"
                      [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"></lucide-icon>
                  </div>
                  }
                  @if (item.isExpanded || isItemSelected(item)) {
                  <div style="flex-basis: 36px;" data-cy="tdo-organizer-lecture-tree-item-open-folder">
                    <lucide-icon [name]="item.children?.length > 0 ? 'folder-open-dot' : isItemSelected(item)?'folder-open':'folder'" [size]="30" 
                      class="tree-item-icon"
                      [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"></lucide-icon>
                  </div>
                  }
                  }
                  <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                    [ngClass]="{'selected-item': isItemSelected(item)}" data-cy="tdo-organizer-lecture-tree-item-name">
                    {{item.name}}</div>
                </div>
              </ng-template>
            </tdo-tree>
            }
          </div>
        </mat-tab>
        }
        @if (!hideFolderPresentationTab) {
        <mat-tab label="Education" data-cy="tdo-organizer-education-tab">
          <div class="image-organizer-tab-content" data-cy="tdo-organizer-education-tab-content">
            @if (folderPresentationTreeData.length > 0) {
            <tdo-tree #libraryTree (itemSelected)="onPatientTreeItemSelected($event)"
              [dataSource]="folderPresentationTreeData" [template]="treeItem4" (itemDrop)="onItemDroppedInTree($event)"
              data-cy="tdo-organizer-education-tree">
              <ng-template #treeItem4 let-item>
                <div (contextmenu)="onLibraryTreeContext($event, item); false"
                  style="display: flex; cursor: pointer; font-size: 14px;" data-cy="tdo-organizer-education-tree-item">
                  @if (item.matIconOverride) {
                  <lucide-icon name="trash-2" [size]="30" 
                    [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"
                    data-cy="tdo-organizer-patient-tree-item-delete-icon"></lucide-icon>
                  }
                  @if (!item.matIconOverride) {
                  @if (!item.isExpanded && !isItemSelected(item)) {
                  <div style="flex-basis: 36px;" data-cy="tdo-organizer-education-tree-item-closed-folder">
                    <lucide-icon [name]="item.children?.length > 0 ? 'folder-input' : 'folder'" [size]="30"
                      class="tree-item-icon"
                      [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"></lucide-icon>
                  </div>
                  }
                  @if (item.isExpanded || isItemSelected(item)) {
                  <div style="flex-basis: 36px;" data-cy="tdo-organizer-education-tree-item-open-folder">
                    <lucide-icon [name]="item.children?.length > 0 ? 'folder-open-dot' : isItemSelected(item)?'folder-open':'folder'" [size]="30" 
                      class="tree-item-icon"
                      [style.color]="isItemSelected(item) ? 'var(--tdo-header)' : 'var(--tdo-primary-accent)'"></lucide-icon>
                  </div>
                  }
                  }
                  <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                    [ngClass]="{'selected-item': isItemSelected(item)}"
                    data-cy="tdo-organizer-education-tree-item-name">{{item.name}}</div>
                </div>
              </ng-template>
            </tdo-tree>
            }
          </div>
        </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
  <div style="flex: 1; display: flex; flex-direction: column; margin-left: 16px; max-width: 100%;"
    data-cy="tdo-organizer-right-panel">
    <div style="flex-basis: 30px; display: flex;" data-cy="tdo-organizer-view-controls">
      <div style="flex: 1;" data-cy="tdo-organizer-file-counts">
        <!--        FORCE THE REMAINING TO THE RIGHT-->
        @if (numImages > 0) {
        <div style="position: relative; top: 20px; font-size: 12px;" data-cy="tdo-organizer-image-count-text">File
          count: {{numImages}}
          Selected Count: {{numSelectedImages}}</div>
        }
      </div>
      @if (viewType === 'pane' || viewType === 'thumbnail' || viewType ==='thumbnail_zoom') {
      <tdo-basic-dropdown style="margin-left: 10px; position: relative; z-index: 20; flex-basis: fit-content;"
        [placeholder]="staticDataSet.imageSizes[4].label" [dataSet]="staticDataSet.imageSizes"
        (itemSelected)="onImageSizeSelected($event)" data-cy="tdo-organizer-image-size-dropdown"></tdo-basic-dropdown>
      }
      <tdo-basic-dropdown style="margin-left: 10px; position: relative; z-index: 20; flex-basis: fit-content;"
        width="172px" [placeholder]="staticDataSet.organizerViews[3].label" [dataSet]="staticDataSet.organizerViews"
        (itemSelected)="onViewTypeSelected($event)" data-cy="tdo-organizer-view-type-dropdown"></tdo-basic-dropdown>
      <tdo-basic-dropdown style="margin-left: 10px; flex-basis: fit-content;"
        [placeholder]="staticDataSet.organizerSortMethods[0].label" [dataSet]="staticDataSet.organizerSortMethods"
        (itemSelected)="onSortSelected($event)" data-cy="tdo-organizer-sort-dropdown"></tdo-basic-dropdown>
      <div class="image-organizer-top-buttons" data-cy="tdo-organizer-action-buttons">
        <input multiple="multiple" #fileInput id="fileInput" style="display:none;" type="file" [accept]="filetypes"
          (change)="fileSelected(fileInput.files)" data-cy="tdo-organizer-file-input" />
        <lucide-icon name="folder" [size]="30" matTooltip="Open File" (click)="fileInput.click()" style="cursor: pointer;"
          data-cy="tdo-organizer-open-file-button"></lucide-icon>        

        <div (click)="openFilters()" matTooltip="Filter"
          style="cursor: pointer; position: relative; top: 3px; margin-right: 2px;"
          [ngClass]="{'is-filter-active': isFilterActive()}" data-cy="tdo-organizer-filter-button">
          <lucide-icon name="filter" [size]="30"></lucide-icon>
        </div>
        <img matTooltip="Open in new tab" (click)="onNewTabClick()" src="assets/Images/image-organizer/new-tab.svg"
          style="margin-left: 2px;" data-cy="tdo-organizer-new-tab-button" />
        <img (click)="openSlideshow()" matTooltip="Slide Show" src="assets/Images/image-organizer/slide-show.svg"
          style="margin-left: 3px;" data-cy="tdo-organizer-slideshow-button" />
        <img (click)="onAscendingToggle()" matTooltip="Sort ASC / DESC" src="assets/Images/image-organizer/sort.svg"
          data-cy="tdo-organizer-sort-toggle" />
        <lucide-icon name="refresh-cw" [size]="26" matTooltip="Reload Images" (click)="reloadImages()"
          style="cursor: pointer; margin-left: 2px; margin-right: 2px; position: relative; top: 2px;"
          data-cy="tdo-organizer-reload-button"></lucide-icon>
      </div>
    </div>
    <div
      style="position: relative; display: flex; flex-direction: column; flex: 1; margin-top: var(--margin-size); background-color: black; border-radius: var(--border-radius); height: 100%; overflow-y: hidden; overflow-x: hidden; padding: 2px;"
      data-cy="tdo-organizer-image-viewer">
      @if (isImagesLoading) {
      <app-tdo-progress-spinner [style.width.px]="gridContainer.nativeElement.getBoundingClientRect().width"
        [style.height.px]="gridContainer.nativeElement.getBoundingClientRect().height"
        style="position: absolute; z-index: 2000;" data-cy="tdo-organizer-loading-spinner"></app-tdo-progress-spinner>
      }
      <div style="width: 100%; height: 100%; display: flex;" (contextmenu)="onEmptyAreaContextMenu($event)"
        data-cy="tdo-organizer-image-content-area">
        @if (viewType === 'pane') {
        <as-split gutterSize="6" unit="percent" direction="horizontal" data-cy="tdo-organizer-pane-view-split">
          <as-split-area size="30" data-cy="tdo-organizer-pane-view-details-area">
            <div
              style="background-color: var(--tdo-primary); width: 100%; height: 100%; padding: 6px; border-radius: var(--border-radius); color: white; font-size: 12px;"
              data-cy="tdo-organizer-pane-view-details-content">
              @if (selectedImages && selectedImages.length > 0) {
              <div style="text-align: left;" data-cy="tdo-organizer-pane-image-container">
                <img
                  [src]="fileManagerService.getDocumentUrlFromDocument(this.selectedImages[this.selectedImages.length - 1].dataDocument) | secureImage | async"
                  style="width: 100%; border-radius: var(--border-radius);" data-cy="tdo-organizer-pane-image" />
              </div>
              <div style="display: flex; margin-top: 6px;" data-cy="tdo-organizer-pane-description">
                <div style="width: 70px; text-align: right; color: #d1d1d1;"
                  data-cy="tdo-organizer-pane-description-label">Description:</div>
                <div style="flex: 1; margin-left: 6px; font-weight: 500;"
                  data-cy="tdo-organizer-pane-description-value">{{this.selectedImages[this.selectedImages.length -
                  1].dataDocument.Description}}</div>
              </div>
              <div style="display: flex;" data-cy="tdo-organizer-pane-filename">
                <div style="width: 70px; text-align: right; color: #d1d1d1;"
                  data-cy="tdo-organizer-pane-filename-label">File name:</div>
                <div style="flex: 1; margin-left: 6px; font-weight: 500;" data-cy="tdo-organizer-pane-filename-value">
                  {{this.selectedImages[this.selectedImages.length - 1].dataDocument.DocumentFileName}}</div>
              </div>
              <div style="display: flex;" data-cy="tdo-organizer-pane-date-taken">
                <div style="width: 70px; text-align: right; color: #d1d1d1;"
                  data-cy="tdo-organizer-pane-date-taken-label">Document Taken/Created:</div>
                <div style="flex: 1; margin-left: 12px; font-weight: 500;"
                  data-cy="tdo-organizer-pane-date-taken-value">
                  <br />{{getDate(this?.selectedImages[this.selectedImages.length -
                  1]?.dataDocument.DocumentCreateDate)}}</div>
              </div>
              <div style="display: flex;" data-cy="tdo-organizer-pane-record-created">
                <div style="width: 70px; text-align: right; color: #d1d1d1;"
                  data-cy="tdo-organizer-pane-record-created-label">Record Created:</div>
                <div style="flex: 1; margin-left: 12px; font-weight: 500;"
                  data-cy="tdo-organizer-pane-record-created-value">
                  <br />{{getDate(this?.selectedImages[this.selectedImages.length - 1]?.dataDocument.xauditCreatedOn)}}
                </div>
              </div>
              <div style="display: flex;" data-cy="tdo-organizer-pane-record-modified">
                <div style="width: 70px; text-align: right; color: #d1d1d1;"
                  data-cy="tdo-organizer-pane-record-modified-label">Record Modified:</div>
                <div style="flex: 1; margin-left: 12px; font-weight: 500;"
                  data-cy="tdo-organizer-pane-record-modified-value">
                  <br />{{getDate(this?.selectedImages[this.selectedImages.length - 1]?.dataDocument.xauditModifiedOn)}}
                </div>
              </div>
              <div style="display: flex;" data-cy="tdo-organizer-pane-categories">
                <div style="width: 70px; text-align: right; color: #d1d1d1;"
                  data-cy="tdo-organizer-pane-categories-label">Categories:</div>
                <div style="flex: 1; margin-left: 6px; font-weight: 500;" data-cy="tdo-organizer-pane-categories-value">
                  {{getCategories(this?.selectedImages[this.selectedImages.length - 1]?.dataDocument.dataDocumentTags)}}
                </div>
              </div>
              <div style="display: flex;" data-cy="tdo-organizer-pane-tooth">
                <div style="width: 70px; text-align: right; color: #d1d1d1;" data-cy="tdo-organizer-pane-tooth-label">
                  Tooth #:</div>
                <div style="flex: 1; margin-left: 6px; font-weight: 500;" data-cy="tdo-organizer-pane-tooth-value">
                  {{this?.selectedImages[this.selectedImages.length - 1]?.dataDocument.listOfTeeth}}</div>
              </div>
              <!--<div style="display: flex;" data-cy="tdo-organizer-pane-case">
                                          <div style="width: 70px; text-align: right; color: #d1d1d1;" data-cy="tdo-organizer-pane-case-label">Case:</div>
                                          <div style="flex: 1; margin-left: 6px; font-weight: 500;" data-cy="tdo-organizer-pane-case-value">{{this?.selectedImages[this.selectedImages.length - 1]?.dataDocument.caseName}}</div>
                                        </div>-->
              }
            </div>
          </as-split-area>
          <as-split-area size="70" data-cy="tdo-organizer-pane-view-grid-area">
            <div style="flex: 1; height: 100%; overflow-y: auto; overflow-x: hidden;" #gridContainer
              data-cy="tdo-organizer-image-grid-container">
              @if ((viewType === 'thumbnail' || viewType === 'thumbnail_zoom' || viewType === 'pane')) {
              <app-tdo-image-grid [ngClass]="{'col-lg-3 bg-secondary': isShowPublish, 'col-lg-12': !isShowPublish}"
                style="height: 100%; width: 100%; overflow-x: hidden; display: flex; flex-wrap:wrap; overflow-wrap: break-word;"
                #tdoImageGrid [isZoomEnabled]="viewType === 'thumbnail_zoom'"
                [isDragEnabled]="!isFilterActive() && selectedPatientTreeNode.type !== 10 && sortType === 'user_defined'"
                [isExternalDragEnabled]="!isFilterActive() && !isTrashFolder(selectedPatientTreeNode)"
                [gridContainer]="gridContainer" [dataSet]="thumbnailImages" [imageLabels]="labelResponseModels"
                [imageTooltips]="tooltipsResponseModels" [isDocumentManagerMode]="true" [boxWidth]="thumbnailImageSize"
                (itemsEntered)="onItemDragEntered($event)" (itemsExited)="onItemDragExited($event)"
                (itemsDropped)="onItemDragDropped($event)" (itemsSorted)="onItemsSorted($event)"
                (itemsSelected)="onGridItemsSelected($event)" (itemDoubleClick)="onItemDoubleClick($event)"
                (contextOpened)="onGridContextMenu($event)"
                (backgroundContextOpen)="onGridBackgroundContextMenu($event)"
                (filesDraggedIntoBrowser)="onFilesDraggedIntoImageGrid($event)" data-cy="tdo-organizer-image-grid">
              </app-tdo-image-grid>
              }
            </div>
          </as-split-area>
        </as-split>
        }
        @if (viewType !== 'pane') {
        <div style=" width: 100%; height: 100%;" data-cy="tdo-organizer-non-pane-view">
          <div style="flex: 1; width: 100%; height: 100%; overflow-y: auto; overflow-x: hidden;" #gridContainer
            data-cy="tdo-organizer-non-pane-grid-container">
            @if ((viewType === 'thumbnail' || viewType === 'thumbnail_zoom' || viewType === 'pane')) {
            <app-tdo-image-grid [ngClass]="{'col-lg-3 bg-secondary': isShowPublish, 'col-lg-12': !isShowPublish}"
              style="height: 100%; width: 100%; overflow-x: hidden; display: flex; flex-wrap:wrap; overflow-wrap: break-word;"
              #tdoImageGrid [isZoomEnabled]="viewType === 'thumbnail_zoom'"
              [isDragEnabled]="!isFilterActive() && selectedPatientTreeNode.type !== 10 && sortType === 'user_defined'"
              [isExternalDragEnabled]="!isFilterActive() && !isTrashFolder(selectedPatientTreeNode)"
              [gridContainer]="gridContainer" [dataSet]="thumbnailImages" [imageLabels]="labelResponseModels"
              [imageTooltips]="tooltipsResponseModels" [isDocumentManagerMode]="true" [boxWidth]="thumbnailImageSize"
              (itemsEntered)="onItemDragEntered($event)" (itemsExited)="onItemDragExited($event)"
              (itemsDropped)="onItemDragDropped($event)" (itemsSorted)="onItemsSorted($event)"
              (itemsSelected)="onGridItemsSelected($event)" (itemDoubleClick)="onItemDoubleClick($event)"
              (contextOpened)="onGridContextMenu($event)" (backgroundContextOpen)="onGridBackgroundContextMenu($event)"
              (filesDraggedIntoBrowser)="onFilesDraggedIntoImageGrid($event)" data-cy="tdo-organizer-thumbnail-grid">
            </app-tdo-image-grid>
            }
            @if (viewType === 'detail') {
            <app-io-view-detail [images]="images" [showThumbnail]="true"
              (onRightClick)="onRightClickContextEvent($event)" (onDblClick)="openImageDetails($event)"
              data-cy="tdo-organizer-detail-view">
            </app-io-view-detail>
            }
            @if (viewType === 'gallery') {
            <app-io-view-gallery [dataset]="images" data-cy="tdo-organizer-gallery-view">
            </app-io-view-gallery>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #imageContextTemplate let-data let-treeItem='data1'>
  <section class="image-context-menu" data-cy="tdo-organizer-image-context-menu">
    @if (isTrashFolder(treeItem)) {
    <div (click)="onRestoreDeletedItems(data)" class="item" data-cy="tdo-organizer-image-context-restore">Restore</div>
    }
    @if (isTrashFolder(treeItem) && treeItem.type !== 10) {
    <div (click)="onRestoreDeletedItems(data, 'specific')" class="item"
      data-cy="tdo-organizer-image-context-restore-specific">Restore to folder</div>
    }
    <div (click)="onGridOpenInImaging(data)" class="item" data-cy="tdo-organizer-image-context-open-studio">Open in Studio</div>
    <!-- <div (click)="onGridOpenInImagingCenter(data)" class="item" data-cy="tdo-organizer-image-context-open-imaging-center">Create Collage</div> -->
    @if (is3DVolume()) {
    <div (click)="onOpen3DVolume()" class="item" data-cy="tdo-organizer-image-context-open-volume">Open Volume</div>
    }
    @if (isPatientTreeOrChild(data) && !isTrashFolder(treeItem)) {
    <!-- Clicks anywhere in this wrapper are stopped from bubbling to document - the shared
         context-menu overlay (openContext/closeContext) closes on the very next document click,
         which would otherwise dismiss this menu after the first checkbox toggle. -->
    <div class="categorize-favorites-wrapper" (click)="$event.stopPropagation()" data-cy="tdo-organizer-image-context-categorize-favorites-wrapper">
      <div (click)="toggleFavoritesSubmenu()" class="item" style="display: flex; align-items: center;" data-cy="tdo-organizer-image-context-categorize-favorites">
        <span style="flex: 1;">Categorize Favorites</span>
        <span>▸</span>
      </div>
      @if (isFavoritesSubmenuOpen) {
      <div class="submenu" data-cy="tdo-organizer-favorites-submenu">
        @if (favoriteCategorizeTags.length === 0) {
        <div class="submenu-empty" data-cy="tdo-organizer-favorites-submenu-empty">No favorites set</div>
        }
        @for (tag of favoriteCategorizeTags; track tag.ValidValueItemId) {
        <label class="submenu-checkbox-item" data-cy="tdo-organizer-favorites-submenu-item-{{tag.ValidValueItemId}}">
          <input type="checkbox" [checked]="isFavoriteCategorizeTagSelected(tag)" (change)="onFavoriteCategorizeTagToggle(tag)">
          <span>{{tag.ItemDisplayValue}}</span>
        </label>
        }
        <button type="button" class="tdo-button tdo-save submenu-apply-btn" [disabled]="selectedFavoriteCategorizeTags.length === 0"
          (click)="onApplyFavoriteCategorizeTags(data)" data-cy="tdo-organizer-favorites-submenu-apply">Apply</button>
      </div>
      }
    </div>
    <div (click)="onGridCategorizeDocumentsClick(data)" class="item" data-cy="tdo-organizer-image-context-categorize">Categorize</div>
    }
    @if (isPatientTreeOrChild(data) && !isTrashFolder(treeItem) && !isMultiSelect(data)) {
    <div (click)="onGridChangeCaseOrToothClick(data)" class="item" data-cy="tdo-organizer-image-context-change-case">Change Case / Tooth</div>
    }
    <div class="spacer"></div>
    @if (!isTrashFolder(treeItem)) {
    <div (click)="onGridCutOrCopy(data, true)" class="item" data-cy="tdo-organizer-image-context-cut">Cut</div>
    }
    @if (treeItem.type !== 10) {
    <div (click)="onGridCutOrCopy(data)" class="item" data-cy="tdo-organizer-image-context-copy">Copy</div>
    }
    @if (!isTrashFolder(treeItem)) {
    <div (click)="onGridPaste()" class="item" data-cy="tdo-organizer-image-context-paste">Paste</div>
    }
    <div class="spacer"></div>
    @if (!isTrashFolder(treeItem)) {
    <div (click)="onDuplicateDocument(data)" class="item" data-cy="tdo-organizer-image-context-duplicate">Duplicate</div>
    }
    <div (click)="onCopyFilePathToClipboard(data)" class="item" data-cy="tdo-organizer-image-context-download">Download</div>
    <div class="spacer"></div>
    @if (!isTrashFolder(treeItem)) {
    <div (click)="onGridDeleteDocumentsClick(data)" class="item" data-cy="tdo-organizer-image-context-delete">Delete</div>
    }
    <div class="spacer"></div>
    @if (!isTrashFolder(treeItem)) {
    <div (click)="onGridMoveDocumentsToTop(data)" class="item" data-cy="tdo-organizer-image-context-move-top">Move to top</div>
    }
    <div class="spacer"></div>
    @if (!isTrashFolder(treeItem)) {
    <div (click)="onPrint(data)" class="item" data-cy="tdo-organizer-image-context-print">Print</div>
    }
  </section>
</ng-template>

<ng-template #lectureContextMenu let-data>
  @if (!isTrashFolder(data)) {
  <section class="image-context-menu" data-cy="tdo-organizer-lecture-context-menu">
    <div (click)="addDocumentFolder(data)" class="item" data-cy="tdo-organizer-lecture-context-add-folder">Add folder
    </div>
    @if (isNotRootNode(data)) {
    <div (click)="renameDocumentFolder(data)" class="item" data-cy="tdo-organizer-lecture-context-rename-folder">Rename
      folder</div>
    }
    <div class="spacer"></div>
    <div (click)="onLibraryLecturePaste(data)" class="item" data-cy="tdo-organizer-lecture-context-paste">Paste</div>
    <div class="spacer"></div>
    @if (isNotRootNode(data)) {
    <div (click)="deleteDocumentFolder(data)" class="item" data-cy="tdo-organizer-lecture-context-delete-folder">Delete
    </div>
    }
  </section>
  }
</ng-template>

<ng-template #patientContextMenu let-data>
</ng-template>

<ng-template #folderBackgroundContextMenu let-data>
  @if (!selectedPatientTreeNode.isPatientTree) {
  <section class="image-context-menu" data-cy="tdo-organizer-folder-background-context-menu">
    @if (!selectedPatientTreeNode.isPatientTree) {
    <div (click)="onGridPaste()" class="item" data-cy="tdo-organizer-folder-background-context-paste">Paste</div>
    }
  </section>
  }
</ng-template>

<ng-template #emptyAreaContextMenu>
  <section class="image-context-menu" data-cy="tdo-organizer-empty-area-context-menu">
    <div (click)="onEmptyAreaPaste()" class="item" data-cy="tdo-organizer-empty-area-context-paste">Paste</div>
  </section>
</ng-template>